(function () {
  let lastVariantId = null;
  let lastDateShown = null;

  function run() {
    const c = document.querySelector('.preorder-dispatch-message');
    if (!c) return;

    const o = c.querySelector('[data-dispatch-date]');
    if (!o) return;

    const productDate = (c.dataset.productDate || '').trim();

    let variants;
    try {
      variants = JSON.parse(c.dataset.variantDates || '[]');
    } catch {
      return;
    }

    const map = {};
    let hasAnyVariantPreorder = false;

    for (const v of variants) {
      if (!v || !v.id) continue;
      const d = typeof v.date === 'string' ? v.date.trim() : '';
      map[String(v.id)] = d;
      if (d.length > 0) hasAnyVariantPreorder = true;
    }

    function getVariantId() {
  const r = document.querySelector(
    'input[type="radio"][data-variant-id]:checked'
  );
  if (r) return String(r.dataset.variantId);

  const s = document.querySelector('select[name*="variant"]');
  if (s && s.value) return String(s.value);

  // 🔑 Producto sin selector de variantes
  if (variants.length === 1 && variants[0].id) {
    return String(variants[0].id);
  }

  return null;
}


    function formatDate(d) {
      if (!d) return '';
      const a = d.split('-');
      if (a.length !== 3) return '';
      const dt = new Date(a[0], a[1] - 1, a[2]);
      if (isNaN(dt)) return '';
      return dt.toLocaleDateString('es-CL', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      });
    }

    const variantId = getVariantId();

    if (!variantId) {
      c.style.display = 'none';
      lastVariantId = null;
      lastDateShown = null;
      return;
    }

    let rawDate = '';

    // 🔑 LÓGICA FINAL CORRECTA
    if (map[variantId]) {
      rawDate = map[variantId];
    } else if (!hasAnyVariantPreorder && productDate) {
      rawDate = productDate;
    } else {
      rawDate = '';
    }

    // Fallback defensivo (casos Horizon incompletos)
    if (!rawDate && !hasAnyVariantPreorder && productDate) {
      rawDate = productDate;
    }

    const formatted = formatDate(rawDate);

    if (
      variantId === lastVariantId &&
      formatted === lastDateShown
    ) {
      return;
    }

    lastVariantId = variantId;
    lastDateShown = formatted;

    if (!formatted) {
      c.style.display = 'none';
      return;
    }

    o.textContent = formatted;
    c.style.display = '';
  }

  run();

  const observer = new MutationObserver(() => {
    window.requestAnimationFrame(run);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
